import { Link } from "react-router-dom";
import styles from "./EvaluationInfo.module.css";
import ArrowLeft from "../../../assets/icons/ArrowLeft.svg";
import Illustration from "../../../assets/icons/Background illustration.png";

export default function EvaluationInfo({
  evaluation,
  onBackClick,
}: {
  evaluation: any;
  onBackClick?: () => void;
}) {
  const timeUntilEvaluation = () => {
    const now = new Date();
    const evaluationDate = new Date(evaluation.colleaguesDueDate);
    const timeDifference = evaluationDate.getTime() - now.getTime();
    // If less than 1 day, return the time difference in hours and minutes
    if (timeDifference < 1000 * 60 * 60 * 24) {
      const hours = Math.floor(timeDifference / (1000 * 60 * 60));
      const minutes = Math.floor(
        (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
      );
      return `${hours} horas e ${minutes} minutos`;
    }
    // If more than 1 day and less than 1 month, return the time difference in days
    else if (timeDifference < 1000 * 60 * 60 * 24 * 30) {
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      return `${days} dias`;
    }
    // If more than 1 month, return the time difference in months and days
    else {
      const months = Math.floor(timeDifference / (1000 * 60 * 60 * 24 * 30));
      const days = Math.floor(
        (timeDifference % (1000 * 60 * 60 * 24 * 30)) / (1000 * 60 * 60 * 24)
      );
      return `${months} meses e ${days} dias`;
    }
  };

  const handleBackClick = (e: React.MouseEvent) => {
    if (onBackClick) {
      e.preventDefault();
      onBackClick();
    }
  };

  return (
    <>
      {/* Background color container */}
      <div className={styles.background}>
        <div className={`${styles.contentContainer} page-container`}>
          <div className={styles.container}>
            <Link
              to="/home"
              className={styles.backLink}
              onClick={handleBackClick}
            >
              <img src={ArrowLeft} alt="Arrow left" />
              VOLTAR PARA O INÍCIO
            </Link>

            <div className={styles.content}>
              <h1 className={styles.title}>Seleção de colegas</h1>

              <div className={styles.info}>
                <p className={styles.infoMainText}>
                  Escolhe 2 pessoas para participarem na tua avaliação
                </p>
                <p className={styles.infoSecondaryText}>
                  1 com quem trabalhas ou já trabalhas-te, 1 com quem tens
                  proximidade no escritório.
                </p>
              </div>

              <div className={styles.time}>
                <p className={styles.timeText}>
                  Tempo restante: {timeUntilEvaluation()}
                </p>
              </div>
            </div>
          </div>

          <img
            src={Illustration}
            alt="Illustration"
            className={styles.illustration}
          />
        </div>
      </div>
    </>
  );
}
